import React from "react";

export default class MsPanelButton extends React.PureComponent {
  render() {
    const btnClass = "button btn " + this.props.classes;
    const clickDefault = this.props.onClickEvent || undefined;
    const btnType = this.props.inputType || "button";

    return (
      <button
        type={btnType}
        name={this.props.id}
        id={this.props.id}
        className={btnClass}
        onClick={clickDefault}
        disabled={!!this.props.disabled}
      >
        {this.props.label}
      </button>
    );
  }
}
